import { Component, inject, OnInit } from '@angular/core';
import { HelperService } from './shared/services/helper.service';
import { Router, NavigationEnd } from '@angular/router';
import { PageMetadataService } from './shared/services/page-metadata.service';
import { environment } from '../environments/environment';
import { Subscription } from 'rxjs';
import { ApiService } from './api.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'obp';
  private helper = inject(HelperService);
  roleSubscription: Subscription;
  private apiService = inject(ApiService);

  selectedRole: any;
  ngOnInit() {
    this.roleSubscription = this.apiService.role$.subscribe((data) => {
      this.selectedRole=data
        });
    // this.helper.fetchMembersList();
    // this.helper.fetchThemeList();
    // this.helper.fetchOverAllGroup();
    // this.helper.fetchParentStandaloneGroupList(this.selectedRole);
  }

}
